(() => {
  'use strict';

  const init = () => {
    const video = document.querySelector('[data-body-video]');
    if (!video) return;

    const section = video.closest('section') || video;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let nearViewport = false;

    const pause = () => {
      if (!video.paused) video.pause();
      video.style.animationPlayState = 'paused';
      section.dataset.p8VideoActive = 'false';
    };

    const canPlay = () => nearViewport && !document.hidden && !reducedMotion.matches;

    const play = () => {
      if (!canPlay()) return;
      video.style.animationPlayState = 'running';
      section.dataset.p8VideoActive = 'true';
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {});
      }
    };

    const sync = () => {
      if (reducedMotion.matches) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
      }

      if (canPlay()) play();
      else pause();
    };

    video.dataset.p8SpeedGuard = 'active';

    video.addEventListener('play', () => {
      if (!canPlay()) {
        window.queueMicrotask(pause);
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          nearViewport = Boolean(entry && entry.isIntersecting);
          sync();
        },
        { rootMargin: '200px 0px', threshold: 0.01 }
      );
      observer.observe(section);
    } else {
      nearViewport = true;
      sync();
    }

    document.addEventListener('visibilitychange', sync, { passive: true });

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', sync);
    } else if (typeof reducedMotion.addListener === 'function') {
      reducedMotion.addListener(sync);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
